import { reduxStateMap } from './reduxMap';
import { actionTypes } from './registryActions';

const initialState = {
    userProfile: { isLoggedIn: false, email: '', companyId: '', role: '' },
    [reduxStateMap.IS_LOADING]: false,
    [reduxStateMap.FORM_VALUES]: {
        [reduxStateMap.VEHICLE_TYPE]: localStorage.getItem(reduxStateMap.VEHICLE_TYPE),
        [reduxStateMap.QUERY_TYPE]: localStorage.getItem(reduxStateMap.QUERY_TYPE)
    }
};

const registryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOG_IN_SUCCESS:
            return {
                ...state,
                [reduxStateMap.USER_PROFILE]: {
                    isLoggedIn: true,
                    email: action.userProfile.profile.email,
                    companyId: action.userProfile.profile.companyId,
                    role: action.userProfile.profile.role
                }
            };
        case actionTypes.LOG_OUT:
            return {
                ...state,
                [reduxStateMap.USER_PROFILE]: initialState.userProfile
            };
        case actionTypes.CONFIGURATION_START: {
            return {
                ...state,
                [reduxStateMap.IS_LOADING]: true
            };
        }
        case actionTypes.CONFIGURATION_FAILURE: {
            return {
                ...state,
                [reduxStateMap.IS_LOADING]: false
            };
        }
        case actionTypes.CONFIGURATION_SUCCESS: {
            return {
                ...state,
                [reduxStateMap.CONFIGURATION]: action.data,
                [reduxStateMap.IS_LOADING]: false
            };
        }
        case actionTypes.SAVE_INPUT_VALUE: {
            const { key, value } = action.data;
            return {
                ...state,
                [reduxStateMap.FORM_VALUES]: {
                    ...state[reduxStateMap.FORM_VALUES],
                    [key]: value
                }
            };
        }
        case actionTypes.QUERY_START: {
            return {
                ...state,
                [reduxStateMap.IS_LOADING]: true,
                [reduxStateMap.DATA]: undefined
            };
        }
        case actionTypes.QUERY_FAILURE: {
            return {
                ...state,
                [reduxStateMap.IS_LOADING]: false
            };
        }
        case actionTypes.QUERY_SUCCESS: {
            return {
                ...state,
                [reduxStateMap.DATA]: action.data,
                [reduxStateMap.IS_LOADING]: false
            };
        }
        default: {
            return state;
        }
    }
};

export default registryReducer;
